import moment from 'moment';
import { Schema } from 'src/utils/form';
import { capitalizeFirstLetter, lowerCaseAllLetter } from 'src/utils/string';
import { TIPO_FILTRO_DATA } from 'src/utils/constants';

export {
  mesclarCamposCustomizados,
  limparCamposCustomizados,
  prepararFiltroParaSalvar,
} from '../matriz-farol/filtro.utils';

export const criarFiltroDefault = () => ({
  id: 0,
  matrizRisco: null,
  tipoFiltroData: { id: TIPO_FILTRO_DATA.ANO_ATUAL },
  dataInicio: null,
  dataTermino: null,
  areas: null,
  areasSubordinadas: false,
  processos: null,
  incluirSubprocessos: false,
  subProcessos: false,
  consolidarRiscosSubItensNosItensSuperiores: false,
  responsaveis: null,
  statusRisco: null,
  scoreRisco: null,
  reducaoImpactoFinanceiro: null,
  impactoFinanceiroResidual: null,
  impactoFinanceiroInerente: null,
  camposCustomizados: [],
});

const CAMPOS_SEM_CHIP = [
  'id',
  'dataInicio',
  'dataTermino',
  'subProcessos',
  'reducaoImpactoFinanceiro',
  'impactoFinanceiroResidual',
  'impactoFinanceiroInerente',
];

export const filtroSchema = Schema.object(
  Object.fromEntries(
    Object.keys(criarFiltroDefault()).map((field) => [
      field,
      CAMPOS_SEM_CHIP.includes(field)
        ? Schema.any().showchip(false)
        : Schema.any().label(''),
    ])
  )
);

export const obterLabelsFiltro = (intl, resources) => {
  const format = (id, values) =>
    capitalizeFirstLetter(intl.formatMessage({ id }, values));

  return {
    matrizRisco: format('labelMatriz'),
    tipoFiltroData: format('label.tipoFiltroData'),
    areas: capitalizeFirstLetter(resources.areas),
    areasSubordinadas: format('label.considerarAreasSubordinadas', {
      areas: resources.areas,
    }),
    processos: format('label.processos', { processos: resources.processos }),
    incluirSubprocessos: format('incluirSubprocessos', {
      processosfilhosplural: resources.processosfilhosplural?.toLowerCase(),
    }),
    consolidarRiscosSubItensNosItensSuperiores: format(
      'labelConsolidarRiscosSubItensSuperiores',
      { riscos: lowerCaseAllLetter(resources.riscos) }
    ),
    responsaveis: capitalizeFirstLetter(resources.responsaveis),
    statusRisco: format('labelStatusRisco', { risco: resources.risco }),
    scoreRisco: format('labelScoreRisco', { risco: resources.risco }),
  };
};

export const normalizarFiltro = (filtro, periodos = [], matrizDefault) => {
  const result = criarFiltroDefault();

  Object.keys(result).forEach((field) => {
    const value = filtro?.[field];
    if (value === undefined) return;
    result[field] =
      field !== 'camposCustomizados' && Array.isArray(value) && !value.length
        ? null
        : value;
  });

  result.matrizRisco = result.matrizRisco?.id
    ? result.matrizRisco
    : matrizDefault || null;

  const tipoFiltroData = result.tipoFiltroData || {
    id: TIPO_FILTRO_DATA.ANO_ATUAL,
  };
  result.tipoFiltroData =
    periodos.find((periodo) => periodo.id === tipoFiltroData.id) ||
    tipoFiltroData;

  if (result.tipoFiltroData.id !== TIPO_FILTRO_DATA.PERIODO) {
    result.dataInicio = null;
    result.dataTermino = null;
  }

  return result;
};

export const obterDescricaoPeriodo = (filtro) => {
  const { tipoFiltroData, dataInicio, dataTermino } = filtro || {};
  const descricao = tipoFiltroData?.descricao || tipoFiltroData?.nome;
  if (!descricao) return undefined;

  if (tipoFiltroData.id === TIPO_FILTRO_DATA.PERIODO && dataInicio) {
    const inicio = moment(dataInicio).format('MM/YYYY');
    const termino = dataTermino ? moment(dataTermino).format('MM/YYYY') : '';
    return `${descricao} (${inicio}${termino ? ' - ' + termino : ''})`;
  }

  return descricao;
};
